import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { JobWorkService } from "./job-work-service";
import { CommonResponseModel, JobWorkDto } from "@project-management-system/shared-models";



@Controller('job-work')
@ApiTags('/job-work')
export class JobWorkController {
    constructor(private service: JobWorkService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllData')
    async getAllData(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllData();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }


    @Post('/createJobWork')
    @ApiBody({ type: JobWorkDto })
    async createJobWork(@Body() req?: any): Promise<CommonResponseModel> {
        try {
            return await this.service.createJobWork(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/updateJobWork')
    @ApiBody({ type: JobWorkDto })
    async updateJobWork(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.service.updateJobWork(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateJobWork')
    @ApiBody({ type: JobWorkDto })
    async activateOrDeactivateJobWork(@Body() dto: any): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateJobWork(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

}